import React, {Component} from 'react';

import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { Nav } from 'react-bootstrap';

import SimpleBar from 'simplebar-react';

import Cookies from "js-cookie";

import {toggleCollapsedNav} from '../../redux/action/Theme';

import SidebarHeader from './SidebarHeader';
import { SidebarMenu } from '../../config/constants/AppConstants';

import classnames from 'classnames';

class Sidebar extends Component {

    constructor(props){
        super(props);
        
        const cookieValue = Cookies.get("sidebarPermit");
        const decoded = cookieValue ? decodeURIComponent(cookieValue) : null;

        this.state = {
            activeMenu: null,
            activeSubMenu: null,
            sidebarPermit: decoded ? JSON.parse(decoded) : null,
        }
    }

    handleClick = (menu) => {
        this.setState({activeMenu: menu});
        if(window.innerWidth <= 1199){ this.props.toggleCollapsedNav(false); }
    }

    setActiveSubMenu = (subMenu) => {
        this.setState({activeSubMenu: subMenu});
    }

    backDropToggle = () => {
        this.props.toggleCollapsedNav(!this.props.navCollapsed);
    }

    render = () => {
        
        const { sidebarPermit, activeMenu, activeSubMenu } = this.state;

        const menuCustomStyles = {
                menuBackgroundColor: '#0e3362',
                activeMenuColor:  '#f99e39',
                inActiveMenuColor: '#D8D8D8FF',
                activeSubMenuColor: '#f99e39',
                inActiveSubMenuColor : '#DEDEDEFF',
        }

        const childrensNavRef = (el) => {
          if (el) {
            const fadeEl = el.querySelector(".fade-mask");
            if (fadeEl) {
              fadeEl.style.display =
                el.scrollWidth > el.clientWidth ? "block" : "none";
            }
          }
        }

        return (
            <>
                <div className="hk-menu"  style={{ backgroundColor: menuCustomStyles.menuBackgroundColor }}>
                    <SidebarHeader />
                    <SimpleBar className="nicescroll-bar">
                        <div className="menu-content-wrap">
                           {SidebarMenu
                            .filter(route => {
                                const UserCookie = Cookies.get("userProfile") ? JSON.parse(Cookies.get("userProfile")) : null;
                                const exceptionSubMenusForType2 = ["masterData"];
                                const isException = UserCookie?.types === "2" && exceptionSubMenusForType2.includes(route.id);
                                
                                return (
                                    isException ||
                                    !route.allowPermits ||
                                    route.allowPermits.some(key => sidebarPermit?.[key] === "0")
                                );
                            })
                            .map((routes, index) => (
                                <React.Fragment key={index}>
                                    <div className="menu-group" >
                                        {routes.group && (<div className="nav-header"><span>{routes.group}</span></div>)}
                                        {routes.contents
                                        .filter(route => {    
                                            const UserCookie = Cookies.get("userProfile") ? JSON.parse(Cookies.get("userProfile")) : null;
                                            const exceptionSubMenusForType2 = ["masterData"];
                                            const isException =["2","5"].includes(UserCookie?.types) && exceptionSubMenusForType2.includes(route.id);

                                            return (
                                                isException ||
                                                !route.allowPermits ||
                                                route.allowPermits.some(key => sidebarPermit?.[key] === "0")
                                            );
                                        })
                                        .map((menus, idx) => (
                                            <Nav bsPrefix="navbar-nav" className="flex-column" key={idx}>
                                                <Nav.Item className={classnames({"active": window.location.pathname === menus.path})}>
                                                    {menus.childrens ? (
                                                        <>
                                                            <Nav.Link
                                                                data-bs-toggle="collapse"
                                                                data-bs-target={`#${menus.id}`}
                                                                aria-expanded={activeMenu === menus.name}
                                                                onClick={() => this.handleClick(menus.name)}
                                                            >
                                                                <span className="nav-icon-wrap"><i className={menus.icon} style={{ color: activeMenu === menus.name && !activeSubMenu ? menuCustomStyles.activeMenuColor : menuCustomStyles.inActiveMenuColor }}/></span>
                                                                <span className="nav-link-text" style={{ color: activeMenu === menus.name && !activeSubMenu ? menuCustomStyles.activeMenuColor : menuCustomStyles.inActiveMenuColor }}>{menus.name}</span>
                                                            </Nav.Link>
                                                            <ul
                                                                id={menus.id}
                                                                className={classnames("nav flex-column nav-children", { "collapse": activeMenu !== menus.name })}
                                                            >
                                                                {menus.childrens
                                                                .filter(route => {
                                                                    const UserCookie = Cookies.get("userProfile") ? JSON.parse(Cookies.get("userProfile")) : null;
                                                                    const exceptionSubMenusForType2 = ["master_data_position"];
                                                                    const exceptionSubMenusForType5 = ["enterprise"];
                                                                    const exceptionSubMenuForBudgetManager = ["enterprise","master_data_expense"];
                                                                    
                                                                    // const isException = (["0","1","2","5"].includes(UserCookie?.types) && exceptionSubMenusForType2.includes(route.allowPermits?.[0])) || (["0","1","5"].includes(UserCookie?.types) && exceptionSubMenusForType5.includes(route.allowPermits?.[0]));
                                                                    
                                                                    /* new case */
                                                                    // const UserCookie = Cookies.get("userProfile") ? JSON.parse(Cookies.get("userProfile")) : null;

                                                                    // const exceptionSubMenusForType2 = ["master_data_position"];
                                                                    // const exceptionSubMenusForType5 = ["enterprise"];

                                                                    const currentPermit = route.allowPermits?.[0];

                                                                    const isException =
                                                                    (["0","1","2","5"].includes(UserCookie?.types) && exceptionSubMenusForType2.includes(currentPermit))
                                                                    ||
                                                                    (["0","1","5"].includes(UserCookie?.types) && exceptionSubMenusForType5.includes(currentPermit))
                                                                    ||
                                                                    (UserCookie?.types === "2" && UserCookie?.subtypes === "0" && exceptionSubMenuForBudgetManager.includes(currentPermit));
                                                                    /* end new case */
                                                                    
                                                                    return (
                                                                        isException ||
                                                                        !route.allowPermits ||
                                                                        route.allowPermits.some(key => sidebarPermit?.[key] === "0")
                                                                    );
                                                                })
                                                                .map((subMenu, indx) => (
                                                                    <li className="nav-item" key={indx}>
                                                                        <Nav.Link
                                                                            as={NavLink}
                                                                            to={subMenu.path}
                                                                            onClick={() => this.setActiveSubMenu(subMenu.name)}
                                                                            className={classnames({ "active": activeSubMenu === subMenu.name })}
                                                                        >
                                                                            <span
                                                                              ref={el => childrensNavRef(el)}
                                                                              title={subMenu.name}
                                                                              style={childrensNavStyle(activeSubMenu, subMenu, menuCustomStyles).childrensNavText}
                                                                            >
                                                                              {subMenu.name}
                                                                              <span
                                                                                className="fade-mask"
                                                                                style={childrensNavStyle(activeSubMenu, subMenu, menuCustomStyles).childrensNavFade}
                                                                              />
                                                                            </span>

                                                                        </Nav.Link>
                                                                    </li>
                                                                ))}

                                                                {/*  New .map for update wording*/}
                                                                {/*
                                                                .map((subMenu, indx) => {
                                                                    const UserCookie = Cookies.get("userProfile")
                                                                        ? JSON.parse(Cookies.get("userProfile"))
                                                                        : null;

                                                                    const displayName =
                                                                        UserCookie?.types === "4" && subMenu.name === "ผู้ใช้งานภายนอก"
                                                                            ? "ประวัติส่วนตัว"
                                                                            : subMenu.name;

                                                                    return (
                                                                        <li className="nav-item" key={indx}>
                                                                            <Nav.Link
                                                                                as={NavLink}
                                                                                to={subMenu.path}
                                                                                onClick={() => this.setActiveSubMenu(displayName)}
                                                                                className={classnames({ "active": activeSubMenu === displayName })}
                                                                            >
                                                                                <span
                                                                                    className="nav-link-text"
                                                                                    style={{
                                                                                        color:
                                                                                            activeSubMenu === displayName
                                                                                                ? menuCustomStyles.activeSubMenuColor
                                                                                                : menuCustomStyles.inActiveSubMenuColor
                                                                                    }}
                                                                                >
                                                                                    {displayName}
                                                                                </span>
                                                                            </Nav.Link>
                                                                        </li>
                                                                    );
                                                                })
                                                                */}
                                                            </ul>
                                                        </>
                                                    ) 
                                                 : 
                                                 (
                                                    <Nav.Link
                                                        as={NavLink}
                                                        to={menus.path}
                                                        onClick={ () => this.handleClick(menus.name) }
                                                    >
                                                        <span className="nav-icon-wrap"  style={{ color: activeMenu === menus.name ? menuCustomStyles.activeMenuColor : menuCustomStyles.inActiveMenuColor }}><i className={menus.icon}></i></span>
                                                        <span className="nav-link-text"  style={{ color: activeMenu === menus.name ? menuCustomStyles.activeMenuColor : menuCustomStyles.inActiveMenuColor }}>{menus.name}</span>
                                                    </Nav.Link>
                                                 )}
                                                </Nav.Item>
                                            </Nav>
                                        ))}
                                    </div>
                                    <div className="menu-gap" />
                                </React.Fragment>
                            ))}
                        </div>
                    </SimpleBar>
                </div>
                <div onClick={() => this.backDropToggle()} className="hk-menu-backdrop"></div>
            </>
        )
    }
}

const childrensNavStyle = (activeSubMenu, subMenu, menuCustomStyles) => {
    return {
    childrensNavText: {
        display: "inline-block",
        maxWidth: "175px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        position: "relative",
        color:
          activeSubMenu === subMenu.name
            ? menuCustomStyles.activeSubMenuColor
            : menuCustomStyles.inActiveSubMenuColor
    },
    childrensNavFade: {
        position: "absolute",
        top: 0,
        right: 0,
        width: "32px",
        height: "100%",
        pointerEvents: "none",
        background: "linear-gradient(to right, rgba(13,44,82,0), #0D2C52)"
    }
    }
}

const mapStateToProps = ({theme}) => {
    const { navCollapsed } = theme;
    return { navCollapsed };
};

export default connect(mapStateToProps, { toggleCollapsedNav }) (Sidebar);